import { useEffect, useState } from "react";

// Visual style of the app: "premium" (default) or "classic".
// Stored per browser so each person can switch back at any time.
const STORAGE_KEY = "lumine_design";
const EVENT = "lumine:design-change";

export const DESIGNS = ["premium", "classic"];

export const getDesign = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return DESIGNS.includes(stored) ? stored : "premium";
  } catch {
    return "premium";
  }
};

export const applyDesign = (design = getDesign()) => {
  document.documentElement.dataset.design = design;
};

export const setDesign = (design) => {
  if (!DESIGNS.includes(design)) return;
  try { localStorage.setItem(STORAGE_KEY, design); } catch { /* keeps working without storage */ }
  applyDesign(design);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: design }));
};

export const useDesign = () => {
  const [design, setState] = useState(getDesign);
  useEffect(() => {
    const onChange = (event) => setState(event.detail);
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, []);
  return [design, setDesign];
};
